<template id="drilldown-b">
    <section>
    <div class = "row ml-3">
        <iframe src="https://forewarn.compegence.com:3000/#!/l1/Territory%20Salesman/state"  height="600" width="100%" frameBorder="0"></iframe>
    </div>
    </section>
</template>
<script>
    export default {
        name: "drilldown-b"
    }
</script>
<style>

</style>